import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import logger from "../../../util/logger";
import * as _ from "../../../util/lodash";
import React from 'react';
import cx from 'classnames';
import { createComponent, PropTypes, Utils } from "../../../wayin-react";
import { whitelistStyles } from "../../core/hoc";
import { directions, sizes, textAlignments, timelineEvents, timelineIcons, widths } from "../../../enums";
import { TextTransformService } from "../../../services";
import Header from "../../core/header";
import Layout from "../../core/layout";
import Label from "../../core/label";
import Icon from "../../core/icon";
import Tooltip from "../../core/tooltip";
import { timelineBadgeColors } from "../../../enums/timeline";
var Timeline = createComponent({
  displayName: 'Timeline',
  propTypes: {
    items: PropTypes.arrayOf(PropTypes.shape(_timelinePropTypes)).isRequired
  },
  contextTypes: {
    isInverted: PropTypes.bool
  },
  render: function render(props) {
    var _context;

    _mapInstanceProperty(_).call(_, props.items, function (item) {
      logger.warn('Prop `items` object must have all properties, `date`, `event`, and `header` defined, in Timeline', !item.date || !item.event || !item.header);
    });

    var _cls = cx('ck', 'timeline', {});

    return /*#__PURE__*/React.createElement("div", {
      className: _cls
    }, _mapInstanceProperty(_context = props.items).call(_context, function (item, i) {
      return /*#__PURE__*/React.createElement(TimelineItem, {
        id: item.id || i,
        key: item.id || i,
        date: item.date,
        event: item.event,
        header: item.header,
        body: item.body
      });
    }, this));
  }
});
var _timelinePropTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.shape({
    content: PropTypes.string,
    userTimeZone: PropTypes.shape({
      name: PropTypes.string,
      offset: PropTypes.string
    })
  })]).isRequired,
  event: PropTypes.oneOfType([PropTypes.oneOf(timelineEvents.ALL), PropTypes.shape({
    content: PropTypes.oneOf(timelineEvents.ALL),
    tooltip: PropTypes.string
  })]).isRequired,
  header: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  body: PropTypes.oneOfType([PropTypes.element, PropTypes.string])
};
var TimelineItem = createComponent({
  displayName: 'TimlineItem',
  propTypes: _timelinePropTypes,
  defaultProps: {
    id: undefined,
    body: undefined
  },
  render: function render(props) {
    return /*#__PURE__*/React.createElement("div", {
      className: "timeline-item",
      key: props.id
    }, /*#__PURE__*/React.createElement(TimelineDate, {
      date: props.date
    }), /*#__PURE__*/React.createElement(TimelineBadge, {
      event: props.event
    }), /*#__PURE__*/React.createElement(TimelineBody, {
      header: props.header,
      body: props.body
    }));
  }
});

var TimelineDate = function TimelineDate(_ref) {
  var date = _ref.date;

  // might need a fallback timezone and date content
  var _date = _.assign({}, date, _extends({}, _.isString(date) && {
    content: date
  }, {
    userTimeZone: {
      name: 'Europe/London',
      offset: '0'
    }
  }));

  return !!date ? /*#__PURE__*/React.createElement("div", {
    className: "timeline-item__date"
  }, /*#__PURE__*/React.createElement(Layout, {
    columnStyles: {
      textAlign: textAlignments.RIGHT
    }
  }, _.isString(date) || /*#__PURE__*/React.isValidElement(date) ? /*#__PURE__*/React.createElement(Layout.Row, null, date) : /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(WrapDate, {
    date: _date
  })))) : null;
};

var TimelineBadge = function TimelineBadge(_ref2) {
  var event = _ref2.event;
  return !!event ? /*#__PURE__*/React.createElement("div", {
    className: "timeline-item__badge"
  }, _.isObject(event) ? /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: event.tooltip
  }, /*#__PURE__*/React.createElement(Icon, {
    name: timelineIcons[event.content],
    color: timelineBadgeColors[event.content],
    size: sizes.X4,
    isCircular: true,
    isSolid: true
  })) : /*#__PURE__*/React.createElement(Icon, {
    name: timelineIcons[event],
    color: timelineBadgeColors[event],
    size: sizes.X4,
    isCircular: true,
    isSolid: true
  })) : null;
};

var TimelineBody = function TimelineBody(_ref3) {
  var header = _ref3.header,
      body = _ref3.body;
  return /*#__PURE__*/React.createElement("div", {
    className: "timeline-item__body"
  }, /*#__PURE__*/React.createElement(Layout, {
    borders: directions.H,
    columns: widths.ONE
  }, !!header && Utils.isType([Header], header) ? /*#__PURE__*/React.createElement(Layout.Row, null, header) : !!header ? /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(Header, {
    size: sizes.X4,
    text: header
  })) : null, !!body && /*#__PURE__*/React.isValidElement(body) ? /*#__PURE__*/React.createElement(Layout.Row, null, body) : !!body ? /*#__PURE__*/React.createElement(Layout.Row, null, /*#__PURE__*/React.createElement(Label, {
    size: sizes.X4,
    text: body
  })) : null));
}; // little defensive code added here in case we have no user value or no date value


var WrapDate = function WrapDate(_ref4) {
  var _ref4$date = _ref4.date,
      content = _ref4$date.content,
      userTimeZone = _ref4$date.userTimeZone;

  // build out each element of the short and long user and date strings
  var _shortDate = shortDate({
    content: content,
    userTimeZone: userTimeZone
  });

  var _longDate = longDate({
    content: content,
    userTimeZone: userTimeZone
  });

  return /*#__PURE__*/React.createElement(Tooltip, {
    width: sizes.M,
    tooltip: _longDate
  }, _shortDate);
}; // only use the TextTransformService if we have a date, otherwise return null


var shortDate = function shortDate(_ref5) {
  var content = _ref5.content,
      userTimeZone = _ref5.userTimeZone;
  return !!content ? TextTransformService.dateTime(content, userTimeZone.name, {
    isRelative: true
  }) : null;
}; // only use the TextTransformService if we have a date, otherwise return null


var longDate = function longDate(_ref6) {
  var content = _ref6.content,
      userTimeZone = _ref6.userTimeZone;
  return !!content ? TextTransformService.dateTime(content, userTimeZone.name, {
    format: 'LLL'
  }) : null;
};

export default whitelistStyles()(Timeline);
//# sourceMappingURL=index.js.map